import React, { useCallback, useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { notifications, PurchaseNotification } from '../data/content';
import { useIsMobile } from '../hooks/useIsMobile';
const CONFIG = {
  desktop: {
    initialDelay: 8000,
    visible: 4000,
    interval: 6000
  },
  mobile: {
    initialDelay: 10000,
    visible: 3500,
    interval: 8000
  }
};
function pickNext(current: number): number {
  if (notifications.length <= 1) return 0;
  let next = current;
  while (next === current) {
    next = Math.floor(Math.random() * notifications.length);
  }
  return next;
}
export function SocialProofPopup() {
  const isMobile = useIsMobile();
  const [active, setActive] = useState<PurchaseNotification | null>(null);
  const [dismissed, setDismissed] = useState(false);
  const lastIndex = useRef(-1);
  const timers = useRef<number[]>([]);
  const config = isMobile ? CONFIG.mobile : CONFIG.desktop;
  const clearTimers = useCallback(() => {
    timers.current.forEach(timer => window.clearTimeout(timer));
    timers.current = [];
  }, []);
  useEffect(() => {
    if (dismissed || !notifications.length) {
      clearTimers();
      setActive(null);
      return;
    }
    const showNext = () => {
      const next = pickNext(lastIndex.current);
      lastIndex.current = next;
      setActive(notifications[next]);
      timers.current.push(window.setTimeout(() => {
        setActive(null);
        timers.current.push(window.setTimeout(showNext, config.interval));
      }, config.visible));
    };
    timers.current.push(window.setTimeout(showNext, config.initialDelay));
    return clearTimers;
  }, [clearTimers, config.initialDelay, config.interval, config.visible, dismissed]);
  return <div className="pointer-events-none fixed bottom-4 left-3 z-50 sm:bottom-5 sm:left-5" data-id="element-166" data-mp="1ezlmb8k5oi28">
      <AnimatePresence data-id="element-167" data-mp="1a23ddi6522u8">
        {active && !dismissed && <motion.div key={`${active.name}-${active.time}`} initial={{
        x: '-120%',
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} role="status" aria-live="polite" className="pointer-events-auto relative w-[220px] max-w-[58vw] rounded-lg border-l-[3px] border-gold bg-navy-mid px-3.5 py-2.5 shadow-[0_8px_24px_-8px_rgba(0,0,0,0.5)] sm:w-[280px] sm:max-w-none" data-id="element-168" data-mp="19z7g7w247i6u">
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute right-1.5 top-1.5 flex h-5 w-5 items-center justify-center rounded-full text-white/40 transition-colors duration-150 ease-out hover:text-white" data-id="element-169" data-mp="24u2x6iwovj4l">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-170" data-mp="2erhcugasg3vu" />
            </button>
            <div className="flex items-center gap-1.5 pr-4" data-id="element-171" data-mp="fgg5zeytw420">
              <CheckCircle2Icon className="h-3.5 w-3.5 shrink-0 text-gold" aria-hidden="true" data-id="element-172" data-mp="kdpu8rahe9o9" />
              <span className="text-[11px] font-bold text-white" data-id="element-173" data-mp="cugn74pg6n2d">Verified purchase</span>
            </div>
            <p className="mt-1 text-[11px] leading-snug text-white/80" data-id="element-174" data-mp="83gmrph4dmv4">
              {active.name} — {active.location}
            </p>
            <p className="mt-0.5 text-[10px] font-medium text-gold" data-id="element-175" data-mp="35f5na397xma">{active.time}</p>
            <p className="mt-0.5 text-[10px] text-white/55" data-id="element-176" data-mp="3uc9j67f5auk9">THE COMPLETE ART YEAR™</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}